import { useQuery } from "@tanstack/react-query";

import { getCarbonProgramOutcomes, simulateCarbonProgramOutcomes } from "services";

import { getLocalKlimVar, useUserContext } from "utils";

import { GET_CARBON_PROGRAM_OUTCOMES } from "consts";

import { CarbonProgramOutcomesResponse } from "models";

export const useGetCarbonProgramOutcomes = ({ fieldIds, enabled, simulationIds }: { fieldIds: string[]; enabled?: boolean; simulationIds?: string[] }) => {
  const { user } = useUserContext();
  const token = getLocalKlimVar("token");

  return useQuery<CarbonProgramOutcomesResponse>({
    queryKey: [GET_CARBON_PROGRAM_OUTCOMES, fieldIds, simulationIds],
    queryFn: () => (simulationIds ? simulateCarbonProgramOutcomes({ simulationIds }) : getCarbonProgramOutcomes({ fieldIds })),
    enabled: enabled && !!user && !!token, // only fetch if user is logged in + extra conditions met
    staleTime: 1000 * 60 * 60 * 24 * 7 * 2, // 2 weeks
  });
};
